import { render, staticRenderFns } from "./TrendKolSummary.vue?vue&type=template&id=5a52d246&scoped=true"
import script from "./TrendKolSummary.vue?vue&type=script&lang=js"
export * from "./TrendKolSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a52d246",
  null
  
)

export default component.exports